// extracted by mini-css-extract-plugin
export default {"siteCardContents":"sites-card-module__siteCardContents--xiXiE"};